// Copied verbatim from https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard

import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'

@Directive({
  selector: '[copy-clipboard]',
  standalone: true,
})
export class CopyClipboardDirective {
  @Input('copy-clipboard')
  public payload: string

  @Output('copied')
  public copied: EventEmitter<string> = new EventEmitter<string>()

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault()
    if (!this.payload) return

    if (!navigator.clipboard) {
      // deprecated way of writing to the clipboard.  Predates the Clipboard API, here for back compat.
      let listener = (e: ClipboardEvent) => {
        let clipboard = e.clipboardData || window['clipboardData']
        clipboard.setData('text', this.payload.toString())
        e.preventDefault()

        this.copied.emit(this.payload)
      }

      document.addEventListener('copy', listener, false)
      document.execCommand('copy')
      document.removeEventListener('copy', listener, false)
    } else {
      navigator.clipboard.writeText(this.payload)
      this.copied.emit(this.payload)
    }
  }
}
